import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, ref } from "vue";
import { TeamSchema } from "@/types";
import { teamColumns } from "@/util";
import {
  memberApiStore,
  saveTeamStore,
  sessionStore,
  teamApiStore,
  teamStore,
} from "@/hooks";
import { navigateTo, QueryParams, Routes } from "@/router";
import {
  PanelCard,
  TextButton,
  IconButton,
  SelectorTable,
} from "@/components/common";
import { SaveTeamInputs } from "@/components/organization/save";


/**
 * A tab for managing teams within an organization.
 */
const __default__ = {
  name: "TeamTab",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const selectedTeam = ref<TeamSchema>();

const loading = ref(false);
const addMode = ref(false);

const selectedTeams = computed({
  get() {
    return selectedTeam.value ? [selectedTeam.value] : [];
  },
  set(teams: TeamSchema[]) {
    selectedTeam.value = teams[0];

    if (teams[0]) {
      teamApiStore.currentTeam = teams[0];
      navigateTo(Routes.TEAM, {
        [QueryParams.TEAM]: teams[0].id,
      });
    }
  },
});

/**
 * Opens the add team form and resets entered data.
 */
function handleOpen() {
  addMode.value = true;
  saveTeamStore.$reset();
}

/**
 * Closes the add team form and resets entered data.
 */
function handleClose() {
  addMode.value = false;
  saveTeamStore.$reset();
}

/**
 * Whether to display the leave button for a team.
 */
function displayLeave(team: TeamSchema): boolean {
  const member = team.members.find(
    ({ email }) => email === sessionStore.userEmail
  );

  return !!member && team.members.length > 1;
}

/**
 * Leaves the selected team.
 */
function handleLeave(team: TeamSchema) {
  const member = team.members.find(
    ({ email }) => email === sessionStore.userEmail
  );

  if (!member) return;

  memberApiStore.handleDelete(member);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), null, {
    "title-actions": _withCtx(() => [
      (addMode.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            label: "Cancel",
            icon: "cancel",
            onClick: handleClose
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!addMode.value)
        ? (_openBlock(), _createBlock(_unref(SelectorTable), {
            key: 0,
            selected: selectedTeams.value,
            "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((selectedTeams).value = $event)),
            addable: "",
            deletable: "",
            columns: _unref(teamColumns),
            rows: _unref(teamStore).allTeams,
            loading: loading.value,
            "row-key": "id",
            "item-name": "team",
            "onRow:add": handleOpen,
            "onRow:delete": _unref(teamApiStore).handleDelete
          }, {
            "cell-actions": _withCtx(({ row }) => [
              (displayLeave(row))
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 0,
                    icon: "leave",
                    tooltip: "Leave team",
                    "data-cy": "button-selector-leave",
                    onClick: ($event: any) => (handleLeave(row))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["selected", "columns", "rows", "loading", "onRow:delete"]))
        : (_openBlock(), _createBlock(_unref(SaveTeamInputs), {
            key: 1,
            onSubmit: handleClose
          }))
    ]),
    _: 1
  }))
}
}

})